import styled from 'styled-components'

export const HomePageWrapper = styled.div`
    overflow: hidden;
`
